// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a4Xyw","footer":"styles_footer__2_xOx","passCodeTooltip":"styles_passCodeTooltip__1s58W"};